<template>
  <div class="containerCol" :style="computedStyle">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'containerCol',
  props: {
    width: {
      type: String,
      default: '300px'
    },
    calcWidth: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '100%'
    },
    padding: {
      type: String,
      default: '0px'
    },
    margin: {
      type: String,
      default: '0px'
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedStyle() {
      let borderStr = 'none'
      if (this.border) {
        borderStr = '1px #cdcfd4 solid'
      }
      let widthStr = this.width;
      if (this.calcWidth) {
        widthStr = 'calc(100% - ' + this.calcWidth + ')'
      }
      return {
        height: this.height,
        width: widthStr,
        padding: this.padding,
        margin: this.margin,
        border: borderStr
      }
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
}
</script>
<style lang="scss" scoped>
.containerCol {
  overflow-y: auto;
}
</style>
<style lang="scss">
.containerCol {}
</style>